import MyMessages from './MyMessages';

export default MyMessages;



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Content/Main/MyMessages/index.js